import { Application } from "@hotwired/stimulus";
import AutoSubmit from "@stimulus-components/auto-submit";
import RailsNestedForm from "@stimulus-components/rails-nested-form";
import TextareaAutogrow from "stimulus-textarea-autogrow";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

application.register("auto-submit", AutoSubmit);
application.register("nested-form", RailsNestedForm);
application.register("textarea-autogrow", TextareaAutogrow);

export { application };
